import React from 'react';
import {injectIntl} from 'react-intl';
import {Glyphicon, Dropdown, MenuItem} from 'react-bootstrap';
import {CHAT_STATE, NEW_CONVERSATION_FORM_STATE, NEW_GROUP_FORM_STATE} from './constants.js'


class MenuBar extends React.Component {

    render(){
        const backButton = (
            <span className="back-btn" onClick={() => this.props.onClickBack()}>
                <Glyphicon glyph="arrow-left" />
            </span>);
        return(
            <div className="conversations-header">
                { this.props.showBackBtn ? backButton : null }
                <div className="app-title">
                    <div className="title-text">
                        {this.props.title}
                    </div>
                </div>
            </div>
        );
    }
}


export default injectIntl(MenuBar);
